module.exports = __webpack_public_path__ + "images/emoji/no_mobile_phones.9ef7f3e860859a76ec13.png";